/**
 * Hook to detect if the page is in embedded mode (iframe)
 * Checks for ?embed=true URL parameter
 */
export function useEmbedMode(): boolean {
  if (typeof window === 'undefined') return false;
  
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('embed') === 'true';
}

/**
 * Append ?embed=true to a URL if currently in embed mode
 */
export function appendEmbedParam(url: string): string {
  if (typeof window === 'undefined') return url;
  
  const urlParams = new URLSearchParams(window.location.search);
  const isEmbedded = urlParams.get('embed') === 'true';
  
  if (!isEmbedded) return url;
  
  // Check if URL already has query params
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}embed=true`;
}
